import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async gravarFotosManifesto(api, parametros) {       
    parametros.operacao = 'gravarFotosManifesto'
    let retorno = {};

    await api.santriPOST('/rest/manifesto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RFotoEntrega.js